// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1Zjh_","description":"PatientConsentPreview_description__3jWAa"};